import { Outlet, useNavigate } from 'react-router-dom';

import { useTranslation } from '@/app/providers';
import { ROUTES } from '@/app/router/route-constants';
import { useBackofficeAuth } from '@/features/backoffice2020/hooks/use-backoffice-auth';
import { BackofficeHeader } from '@/widgets/backoffice-header/backoffice-header';

export function BackofficeLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout, isLoggingOut } = useBackofficeAuth();

  const handleLogout = async () => {
    if (isLoggingOut) return;
    await logout();
    void navigate(ROUTES.BACKOFFICE_LOGIN, { replace: true });
  };

  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden overscroll-none bg-content-bg">
      <BackofficeHeader
        showLogout
        isLoggingOut={isLoggingOut}
        onLogout={() => {
          void handleLogout();
        }}
      />
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
        <div className="relative flex min-h-full flex-col">
          <div className="flex-1">
            <Outlet />
          </div>
          <footer className="shrink-0 border-t px-4 py-3 text-sm text-secondary sm:px-8 md:px-12">
            {t('backoffice2020.footer', {
              year: String(new Date().getFullYear()),
            })}
          </footer>
        </div>
      </div>
    </div>
  );
}
